import LayoutCenter from "./components/Center"
import LayoutDefault from "./components/Default"

const Layout = {
    Center: LayoutCenter,
    Default: LayoutDefault,
}

export default Layout